$(document).on("turbolinks:load", function (){
  if ($(".has-sub-menu.selected").length) {
    $('.menu-w').addClass("sub-menu-open");
  }
})